import { Fragment, Suspense, useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Spinner } from '~/components/Spinner';
import { cn } from '~/lib/cn';
import { BrandContext } from '~/modules/branding';
import { GlobalSearch } from '~/modules/global-search';
import { Nav } from '~/modules/navigation/components';
import { MusicIQIntroModal } from '~/modules/navigation/components/MusicIQIntroModal';

export function PrimaryLayout(): React.ReactNode {
  const brand = useContext(BrandContext);
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const OutletWrapper = brand.name === 'WMG' ? GlobalSearch : Fragment;

  return (
    <>
      <aside
        className={cn(
          'fixed left-0 top-0 z-20 h-dvh overflow-y-auto overflow-x-hidden overscroll-y-contain transition-all duration-150',
          isNavExpanded ? 'w-[12.5rem]' : 'w-[4.5rem]',
        )}
        data-testid="main-nav-sidebar"
      >
        <Nav expanded={isNavExpanded} setExpanded={setIsNavExpanded} />
      </aside>
      <div
        className={cn(
          'flex min-h-dvh w-full min-w-0 overscroll-contain transition-all duration-150',
          isNavExpanded ? 'ml-[12.5rem]' : 'ml-[4.5rem]',
        )}
      >
        <OutletWrapper>
          <Suspense
            fallback={
              <div className="flex h-full flex-1 items-center justify-center">
                <Spinner />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </OutletWrapper>
        {brand.name === 'WMG' && <MusicIQIntroModal />}
      </div>
    </>
  );
}

PrimaryLayout.displayName = 'PrimaryLayout';
